class ProjectsAPI {

  static all(state) {

    let urls = [];

    if (window.location.href.indexOf('localhost') > -1) {
      urls = this.urls('dev');
    } else if (window.location.href.indexOf('bureaubright') > -1) {
      urls = this.urls('staging');
    } else {
      urls = this.urls('production');
    }

    // fetch all urls and return promises
    return urls.map(url => {
      return fetch(url).then(response => {

        if (!response.ok) {
          throw Error(`Request rejected with status ${response.status}`);
        }

        return response.json();
      });
    });
  }

  static urls(env) {

    let urls = [];

    switch (env) {
      case 'dev':
        urls = [
          '/wp-json/barth/v1/news_projects',
          '/wp-json/barth/v1/news_projects',
          '/wp-json/barth/v1/news_projects',
          '/wp-json/barth/v1/news_projects',
          '/wp-json/barth/v1/news_projects',
        ];
        break;
      case 'staging':
        urls = [
          'https://barthinstallatietechniek.bureaubright.nl/wp-json/barth/v1/news_projects',
          'https://barthindustrialautomation.bureaubright.nl/wp-json/barth/v1/news_projects',
          'https://aldonk.bureaubright.nl/wp-json/barth/v1/news_projects',
          'https://controlscope.bureaubright.nl/wp-json/barth/v1/news_projects',
          'https://enginengineering.bureaubright.nl/wp-json/barth/v1/news_projects',
        ];
        break;
      case 'production':
        urls = [
          'https://barthinstallatietechniek.nl/wp-json/barth/v1/news_projects',
          'https://barthindustrialautomation.com/wp-json/barth/v1/news_projects',
          'https://aldonk.com/wp-json/barth/v1/news_projects',
          'https://controlscope.nl/wp-json/barth/v1/news_projects',
          'https://enginengineering.com/wp-json/barth/v1/news_projects',
          'https://barthgroep.nl/wp-json/barth/v1/news_projects',
        ];
        break;
    }

    return urls;
  }

}

export default ProjectsAPI;

// WEBPACK FOOTER //
// ./src/js/news/api/ProjectsAPI.js